<script setup>
// Fetch locale
const { locale } = useI18n()
const localePath = useLocalePath()
const siteUrl = useSiteUrl()

useHead(() => ({
    link: [
        {
            rel: 'canonical',
            href: locale.value === 'de'
                ? `${siteUrl}${localePath('faq')}`
                : ''
        }
    ]
}))

// Track Page Load
trackPageLoad({
    title: TRACKING_CONSTANTS.TITLES.FAQ_PAGE,
})
</script>

<template>
    <PageMainContainer :page-main-container-config="{ appFooter: true }">
        <FaqContent />
    </PageMainContainer>
</template>
